import React, { useState, useEffect } from "react";
import "./style.scss";

const ProgressBar = props => {
  const [progress, setprogress] = useState();

  useEffect(() => {
    setTimeout(() => {
      setprogress(props.state.progressTo);
    }, 500);
  }, [props.state.progressTo]);

  return (
    <>
      {props.state.showProgressBar && (
        <div className="text-left progress-bar-ip">
          <div className="progress-bar-ip__wrapper">
            <div className="progress-bar-ip__filled" style={{ width: props.state.progressFrom }} />
            <div className="progress-bar-ip__fill" style={{ width: progress }} />
          </div>
          <div className="progress-bar-ip__text-wrapper">
            <span className="progress-bar-ip__text">{props.state.text}</span>
          </div>
        </div>
      )}
    </>
  );
};

ProgressBar.defaultProps = {
  state: {
    showProgressBar: false,
    progressTo: 0,
    progressFrom: 0,
    text: ""
  }
};

export default ProgressBar;
